module.exports = __webpack_public_path__ + "static/media/ricardo.02b80fd8.svg";